import http from './http';
import demoData from '../mock/demoData';

const isDemo = () => sessionStorage.getItem('sas_demo') === '1';
const read = (key, request) => isDemo() ? Promise.resolve(demoData[key]) : request();
const write = (request) => isDemo() ? Promise.reject({ userMessage: '演示模式仅供浏览，保存操作已禁用' }) : request();

const api = {
  demoActor: demoData.actor,
  login: ({ username, password }) => http.post('/api/auth/login', { username, password }),
  me: () => http.get('/api/auth/me'),
  logout: () => isDemo() ? Promise.resolve() : http.post('/api/auth/logout'),
  password: (data) => write(() => http.post('/api/auth/password', data)),
  dashboard: () => read('dashboard', () => http.get('/api/dashboard/summary')),
  stores: (params) => read('stores', () => http.get('/api/stores', { params })),
  users: (params) => read('users', () => http.get('/api/users', { params })),
  user: (id) => isDemo() ? Promise.resolve(demoData.users.items.find((user) => user.id === id)) : http.get(`/api/users/${id}`),
  roles: (params) => read('roles', () => http.get('/api/roles', { params })),
  permissionsTree: () => read('permissions', () => http.get('/api/permissions/tree')),
  createStore: (data) => write(() => http.post('/api/stores', data)),
  updateStore: (id, data) => write(() => http.put(`/api/stores/${id}`, data)),
  deleteStore: (id) => write(() => http.delete(`/api/stores/${id}`)),
  uploadLogo: (storeId, file) => write(() => {
    const data = new FormData();
    data.append('store_id', String(storeId));
    data.append('file', file);
    return http.post('/api/uploads/logo', data);
  }),
  createRole: (data) => write(() => http.post('/api/roles', data)),
  updateRole: (id, data) => write(() => http.put(`/api/roles/${id}`, data)),
  deleteRole: (id) => write(() => http.delete(`/api/roles/${id}`)),
  createUser: (data) => write(() => http.post('/api/users', data)),
  updateUser: (id, data) => write(() => http.put(`/api/users/${id}`, data)),
  deleteUser: (id) => write(() => http.delete(`/api/users/${id}`)),
  aiSettings: () => read('aiSettings', () => http.get('/api/ai/settings')),
  updateAiSettings: (data) => write(() => http.put('/api/ai/settings', data)),
  aiUsage: (params) => read('aiUsage', () => http.get('/api/ai/usage', { params }))
};

// Selectors must include stores beyond the first page of the management table.
api.allStores = async () => {
  const items = [];
  let page = 1;
  let total = Infinity;
  while (items.length < total) {
    const result = await api.stores({ page, per_page: 100 });
    const rows = result.items || result || [];
    items.push(...rows);
    total = result.total === undefined ? items.length : result.total;
    if (!rows.length || isDemo()) break;
    page += 1;
  }
  return items;
};
export default api;

